// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.General_manag_parents {
  font-family: Inter;
}
.General_manag_parents .General_manag_dashboard_heading {
  color: #000;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -0.88px;
}
.General_manag_parents .gm_design {
  border-radius: 16px;
  box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);
  max-width: 200px;
}
.General_manag_parents .gm_design .gm_estate {
  color: #516900;
  font-weight: 700;
  font-size: 18px;
}
.General_manag_parents .gm_design .gm_logo {
  width: 32px;
  height: 32px;
}
.General_manag_parents .gm_search_application {
  width: 170px;
  padding: 16px, 17px, 16px, 17px;
  border-radius: 12px;
  gap: 10px;
  background: #323e4a;
  border-radius: 12px;
  box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);
}
.General_manag_parents .gm_search_application .gm_title {
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.04em;
  text-align: left;
  color: #ffffff;
}
.General_manag_parents .gm_search_application .gm_logo {
  width: 22px;
  height: 14px;
  padding: 2px 6px;
  border-radius: 9px;
  background-color: #ffffff;
}

.card-truncate {
  width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Employee_search_result {
  font-family: Inter;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #45852e;
}

.md-card-header {
  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.1rem;
  letter-spacing: -0.02em;
  text-align: left;
}

.gm-dashboard-1,
.gm-dashboard-2 {
  font-family: Inter;
  font-size: 3.5rem;
  font-weight: 600;
  line-height: 3.5rem;
  letter-spacing: -0.02em;
  text-align: left;
  color: #000000;
}

.gm-dashboard-3,
.gm-dashboard-4 {
  font-family: Inter;
  font-size: 3.5rem;
  font-weight: 600;
  line-height: 3.5rem;
  letter-spacing: -0.02em;
  text-align: left;
  color: #ffffff;
}

.gm-dashboard-subtext-1,
.gm-dashboard-subtext-2 {
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 0.963rem;
  text-align: left;
  color: #000000;
}

.gm-dashboard-subtext-3,
.gm-dashboard-subtext-4 {
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 0.963rem;
  text-align: left;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/features/modules/UserManagement/EmployeeModule/Dashboard.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AACR;AAEI;EACI,mBAAA;EACA,oDAAA;EACA,gBAAA;AAAR;AAEQ;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AAAZ;AAGQ;EACI,WAAA;EACA,YAAA;AADZ;AAKI;EACI,YAAA;EACA,+BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,oDAAA;AAHR;AAKQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAHZ;AAMQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAJZ;;AASA;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AANJ;;AASA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AANJ;;AASA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AANJ;;AASA;;EAEI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AANJ;;AASA;;EAEI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AANJ;;AASA;;EAEI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AANJ;;AASA;;EAEI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AANJ","sourcesContent":[".General_manag_parents {\n    font-family: Inter;\n\n    .General_manag_dashboard_heading {\n        color: #000;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 110%;\n        letter-spacing: -0.88px;\n    }\n\n    .gm_design {\n        border-radius: 16px;\n        box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);\n        max-width: 200px;\n\n        .gm_estate {\n            color: #516900;\n            font-weight: 700;\n            font-size: 18px;\n        }\n\n        .gm_logo {\n            width: 32px;\n            height: 32px;\n        }\n    }\n\n    .gm_search_application {\n        width: 170px;\n        padding: 16px, 17px, 16px, 17px;\n        border-radius: 12px;\n        gap: 10px;\n        background: #323e4a;\n        border-radius: 12px;\n        box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);\n\n        .gm_title {\n            font-family: Inter;\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 26px;\n            letter-spacing: -0.04em;\n            text-align: left;\n            color: #ffffff;\n        }\n\n        .gm_logo {\n            width: 22px;\n            height: 14px;\n            padding: 2px 6px;\n            border-radius: 9px;\n            background-color: #ffffff;\n        }\n    }\n}\n\n.card-truncate {\n    width: 140px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.Employee_search_result {\n    font-family: Inter;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: #45852e;\n}\n\n.md-card-header {\n    font-family: Inter;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.1rem;\n    letter-spacing: -0.02em;\n    text-align: left;\n}\n\n.gm-dashboard-1,\n.gm-dashboard-2 {\n    font-family: Inter;\n    font-size: 3.5rem;\n    font-weight: 600;\n    line-height: 3.5rem;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: #000000;\n}\n\n.gm-dashboard-3,\n.gm-dashboard-4 {\n    font-family: Inter;\n    font-size: 3.5rem;\n    font-weight: 600;\n    line-height: 3.5rem;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: #ffffff;\n}\n\n.gm-dashboard-subtext-1,\n.gm-dashboard-subtext-2 {\n    font-family: Inter;\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 0.963rem;\n    text-align: left;\n    color: #000000;\n}\n\n.gm-dashboard-subtext-3,\n.gm-dashboard-subtext-4 {\n    font-family: Inter;\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 0.963rem;\n    text-align: left;\n    color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
